var React = require('react');

function Triangle (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","stroke":"#29323D","strokeWidth":"5","d":"M125,16.7569391 L245.328707,197.25 L4.67129273,197.25 L125,16.7569391 Z"}));
}

Triangle.defaultProps = {"width":"250","height":"200","viewBox":"0 0 250 200"};

module.exports = Triangle;

Triangle.default = Triangle;
